export default {
  dbl_dashboard_list_dashboard_name: "Dashboard Name",
  dbl_dashboard_list_status: "Status",
  dbl_dashboard_list_search_dashboard: "Search by dashboard name or creator",
  dbl_dashboard_list_new_dashboard: "New Dashboard",
  dbl_dashboard_list_my_dashboard: "Dashboard Center",
  dbl_dashboard_access_title_dashboard: "Dashboard Access",
  dbl_dashboard_access_title_chart: "Chart Access",
  dbl_dashboard_access_title_cube: "Access",
  dbl_dashboard_access_title_sql_view: "SQL View Access",
  dbl_dashboard_access_edit: "Edit Access",
  dbl_dashboard_access_info: "The access of the dashboard will synchronously be effective in the chart.",
  dbl_dashboard_access_chart_info: "This list of users can also alter associated charts.",
  dbl_dashboard_access_success: "The edit permission has been set successfully.",
  dbl_dashboard_access_error: "Editing permission modification failed! Error code {code}.",
  dbl_dashboard_access_placeholder: "Search for the users you want to add.",
  dbl_dashboard_access_user: "User",
  dbl_dashboard_access_access: "Role",
  dbl_dashboard_access_add: "Add user",
  dbl_dashboard_access_viewer: "Viewer",
  dbl_dashboard_access_developer: "Editor (can publish)",
  dbl_dashboard_access_sql_view_developer: "Editor",
  dbl_dashboard_list_more: "More",
  dbl_dashboard_list_tab_dashboard: 'All ({count})',
  dbl_dashboard_list_tab_dashboard_no_count: 'All',
  dbl_dashboard_list_tab_my_dashboard: 'My Dashboard ({count})',
  dbl_dashboard_list_tab_share_with_me: 'Shared with Me ({count})',
  dbl_dashboard_list_tab_game_template: 'Game Template ({count})',
  dbl_dashboard_list_tab_public_template: 'Public Template ({count})',
  dbl_dashboard_list_set_template: 'Set as Template',
  dbl_dashboard_list_template_type: 'Template Type',
  dbl_dashboard_list_game_template: 'Game Template',
  dbl_dashboard_list_public_template: 'Public Template',
  dbl_dashboard_list_template_name: 'Template Name',
  dbl_dashboard_list_set_template_public_info: 'Users with',
  dbl_dashboard_list_set_template_game_info: 'Users with',
  dbl_dashboard_list_set_template_game_info_detail: 'can view the dashboard on the homepage\'s Template Center',
  dbl_dashboard_list_set_template_game_info_permissions: ' Datalab permissions ',
  dbl_dashboard_list_save_template: 'Save as Template',
  dbl_dashboard_list_save_template_icon_info: 'Setting the dashboard as a template allows users to view it on the homepage Template Center and Dashboard page. ',
  dbl_dashboard_list_dashboard_placeholder: "Please enter a dashboard name",
  dbl_dashboard_list_template_placeholder: "Please enter a template name",
  dbl_dashboard_list_template_set_success: "The template has been set successfully.",

  dbl_dashboard_copy_title: "Copy Dashboard",
  dbl_dashboard_copy_name: "Dashboard Name",
  dbl_dashboard_copy_charts_in: "Charts in Dashboard",
  dbl_dashboard_copy_charts_in_info: "Selecting copy will also create a new chart, selecting reference will not create a new chart",
  dbl_dashboard_copy_charts_in_refer: "Referencing Charts",
  dbl_dashboard_copy_charts_in_copy: "Copying Charts",
  dbl_dashboard_copy_name_repeat: "This name already exists. Please choose another.",
  dbl_dashboard_copy_success: "Copy Successfully! Click to view the ",
  dbl_dashboard_copy_fail: "Copy Failed",
};